import React from 'react';
import styles from '../Dana/styles.css';

const Indonesia = () => {
  return (
    <div className={styles['tnc-wrapper']}>
      <h5>DAFTAR BARANG DAN/ATAU KONTEN YANG DILARANG</h5>
      <ol type="I">
        <li>
          <strong>Memuat konten negatif</strong>
          <ol type="i">
            <li>
              Pornografi
              <ol type="a">
                <li>
                  Pornografi gambar, sketsa, ilustrasi, foto, tulisan, suara,
                  bunyi, gambar bergerak, animasik, kartun, percakapan, gerak
                  tubuh, atau bentuk pesan lainnya yang memuat kecabulan atau
                  eksploitasi seksual yang melanggar norma kesusilaan dalam
                  masyarakat
                </li>
                <li>Jasa pornografi</li>
              </ol>
            </li>
            <li>
              Barang dewasa penunjang kegiatan seksual, termasuk namun tidak
              terbatas pada:
              <ol type="a">
                <li>Obat kuat</li>
                <li>Obat perangsang</li>
                <li>
                  Alat bantu seks (<em>sex toys</em>)
                </li>
                <li>
                  Obat-obatan dewasa, kecuali untuk alat kesehatan (kontrasepsi)
                  yang diizinkan untuk diperjualbelikan oleh peraturan hukum
                  yang berlaku di Indonesia
                </li>
              </ol>
            </li>
            <li>
              Barang dan/atau jasa yang memuat konten perjudian, lotere,
              dan/atau taruhan
            </li>
            <li>
              Barang dan/atau jasa yang memuat konten dengan materi kebencian
            </li>
            <li>
              Barang dan/atau jasa yang memuat konten yang melanggar hak
              kekayaan intelektual:
              <ol type="a">
                <li>
                  Barang bajakan (barang yang merupakan hasil
                  salinan/penggandaan illegal untuk tujuan komersil)
                </li>
                <li>
                  Barang palsu (barang yang diproduksi dan/atau diperdagangkan
                  sebagai tiruan, replika, atau imitasi barang lain atau barang
                  yang menggunakan merek yang sama pada keseluruhannya dengan
                  merek terdaftar milik pihak lain)
                </li>
              </ol>
            </li>
            <li>
              Barang dan/atau jasa yang memuat konten peretasan dan/atau
              menyediakan akses tanpa hak atau melawan system elektronik
            </li>
            <li>
              Barang dan/atau jasa yang memuat konten penyediaan dan/atau
              menyediakan akses terhadap narkoba, zat adiktif, dan psikotropika
            </li>
            <li>
              Barang dan/atau jasa yang memuat konten dengan materi
              ketidakjujuran, kecurangan atau menyesatkan orang lain.
              (Contohnya, hal mistis atau takhayul (Jimat-jimat, benda-benda
              yang diklaim berkekuatan gaib dan memberi ilmu kesaktian),
              penipuan, jasa pencucian uang, jasa pemalsuan dokumen (ijazah,
              sertifikat, surat dokter, kwitansi, dan lain sebagainya))
            </li>
            <li>
              Barang dan/atau jasa yang memuat konten perdagangan manusia
              (jenazah manusia) dan/atau bagian organ manusia
            </li>
          </ol>
        </li>
        <li>
          <strong>
            Tidak memiliki perizinan untuk diperdagangkan sesuai dengan
            ketentuan perundang-undangan
          </strong>
          <ol type="i">
            <li>
              Barang dan/atau jasa terkait dengan senjata, militer, dan peledak
              (Contoh: Senjata api, senjata udara, amunisi, senjata bius,
              senapan, kelengkapan senjata api, replika senjata api, airsoft
              gun, air gun, dan peluru atau sejenis peluru, bahan peledak,
              senjata tajam, serta jenis senjata lainnya. Termasuk barang yang
              berkaitan dengan pemerintah atau institusi negara seperti lencana,
              tanda pangkat atau seragam)
            </li>
            <li>
              Barang dan/atau jasa yang memperjualbelikan tanaman dan/atau
              binatang yang dilindungi
            </li>
            <li>
              Barang dan/atau jasa yang memuat konten tentang alat dan/atau
              perangkat yang dilarang dan/atau yang tidak tersetrifikasi oleh
              kementrian/lembaga
            </li>
            <li>
              Barang dan/atau jasa yang memuat konten tentang bahan kimia yang
              beracun dan berbahaya (bahan yang diklasifikasikan sebagai bahan
              kimia berbahaya menurut Peraturan Menteri Perdagangan yang
              berlaku)
            </li>
          </ol>
        </li>
      </ol>
    </div>
  );
};

export default Indonesia;
